import {
  Component, Inject, OnInit, OnDestroy,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';

import { AuthService } from 'src/app/services/auth.service';
import { EntityService } from 'src/app/services/entity.service';
import { UploadFileComponent } from 'src/app/components/upload-file/upload-file.component';  // <— NEW
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-edit-avatar',
  templateUrl: './edit-avatar.component.html',
  styleUrls: [ './edit-avatar.component.scss' ],
})
export class EditAvatarComponent implements OnInit, OnDestroy {
  loggedIn$ = false;
  user$: Observable<any>;
  entity$: Observable<any>;
  logoSrc!: string;
  fileTypeInS3 = 'USER_AVATAR' as const;

  private loggedInSubscription!: Subscription;
  private userSubscription!: Subscription;

  @ViewChild(UploadFileComponent) uploadFileComponent!: UploadFileComponent;

  constructor(
    private authService: AuthService,
    private entityService: EntityService,
    private usersService: UsersService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditAvatarComponent>,
  ) {}

  ngOnInit(): void {
    this.user$ = this.authService.user$;
    this.entity$ = this.authService.entity$;

    this.loggedInSubscription = this.authService.loggedIn$
      .subscribe((status: boolean) => {
        this.loggedIn$ = status;
        if (status) {
          this.loadEntityLogo();
        }
      });
  }

  ngOnDestroy(): void {
    this.loggedInSubscription?.unsubscribe();
    this.userSubscription?.unsubscribe();
  }

  loadEntityLogo(): void {
    this.authService.user$.subscribe(user => {
      if (user?.loginName) {
        this.entityService.getEntityLogo(user.loginName).subscribe({
          next: (response: any) => {
            if (response?.data?.logoUrl) {
              this.logoSrc = response.data.logoUrl;
            }
          },
          error: err => console.error('Failed to load entity logo:', err),
        });
      }
    }).unsubscribe();
  }

  saveAvatar(): void {
    this.uploadFileComponent.startUpload(new Event(''));
    this.dialogRef.close();
  }

  removeImage(): void {
    if (!this.uploadFileComponent) {
      console.error('Cannot remove image: child UploadFileComponent not yet instantiated.');
      return;
    }
    this.uploadFileComponent.removeCurrentAvatar();
    setTimeout(() => {
      this.usersService.triggerLogoReload();
    }, 1000);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
